const EnvVarKeys = [
  'NEXT_PUBLIC_ENV',
  'NEXT_PUBLIC_APP_URL',
  'NEXT_PUBLIC_HOMEPAGE_URL',
  'NEXT_PUBLIC_CLIENTS_APP_URL',
  'NEXT_PUBLIC_SENTRY_DSN',
  'NEXT_PUBLIC_SENTRY_TUNNEL',
  'NEXT_PUBLIC_INTERCOM_APP_ID',
  'NEXT_PUBLIC_GTM_CONTAINER_ID',
  'NEXT_PUBLIC_SHOW_ANNOTATIONS_TOOLBAR',
  'NEXT_PUBLIC_BUILD_SHA',
  'NEXT_PUBLIC_BUILD_TIME',
  'NEXT_PUBLIC_API_V2_ENDPOINT',
  'NEXT_PUBLIC_STORAGE_ENDPOINT',
  'VITE_PUSH_TAX_RETURN',
  'NODE_ENV'
] as const

type EnvVarKey = (typeof EnvVarKeys)[number]

/**
 * Get the value of the environment variable from the process
 * @param key
 * @returns
 */
export function envVar(key: EnvVarKey): string | undefined {
  return process.env[key] ?? import.meta.env[key]
}

export function clientAppBaseUrl() {
  return envVar('NEXT_PUBLIC_CLIENTS_APP_URL')!
}

export const NODE_ENV = envVar('NODE_ENV')

export const FEATURE_FLAGS = {
  pushTaxReturn: parseBooleanEnv(envVar('VITE_PUSH_TAX_RETURN'))
}

function parseBooleanEnv(value: string | undefined) {
  return value == 'true' || value == '1'
}
